import stateData from '../data/state-rules.json' with { type: 'json' };
const raw = stateData;
const defaults = raw.defaults;
const profileByState = new Map();
for (const stateKey of Object.keys(raw.states)) {
    const override = raw.states[stateKey] ?? {};
    profileByState.set(stateKey, {
        ...defaults,
        ...override,
        lboParagraphMap: {
            ...defaults.lboParagraphMap,
            ...(override.lboParagraphMap ?? {}),
        },
    });
}
/**
 * Liefert das Regel-Profil für ein Bundesland.
 * Fallback: MBO-Defaults wenn kein Profil bekannt.
 */
export function getStateRules(state) {
    if (state && profileByState.has(state))
        return profileByState.get(state);
    return defaults;
}
/**
 * LBO-Paragraphen-Verweis für ein bestimmtes Feld, abhängig vom Bundesland.
 * Wird in KI-Prompts und Tooltips genutzt.
 */
export function getLboParagraph(state, field) {
    return getStateRules(state).lboParagraphMap[field];
}
/**
 * Beschriftung „LBO BW", „BayBO" etc. für UI-Anzeige.
 */
export function getLboAbbr(state) {
    return getStateRules(state).lboAbbr;
}
/**
 * Erläuterung zu einem Schwellenwert des Bundeslands — warum er fehlt oder von
 * der Musterbauordnung abweicht. `null`, wenn es nichts zu erklären gibt.
 *
 * Wird überall dort angezeigt, wo der Wert selbst steht: eine ausgesetzte Regel
 * ohne Begründung sieht aus wie ein Fehler im Werkzeug.
 */
export function getStateHinweis(state, fieldKey) {
    return getStateRules(state).hinweise?.[fieldKey] ?? null;
}
export const stateRulesLastVerified = raw.lastVerified;
export const stateRulesVersion = raw.version;
